import React from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import Snippets from 'components/TemplateForm/Snippets/Snippets'
import styles from 'components/AddOrEditTaskPage/styles'

export default connect(
  (state) => ({ navDisplayed: state.email.bottomNavigationDisplayed }),
  null,
)(
  withStyles(styles)(({ classes, navDisplayed }) => (
    <div style={{ backgroundColor: '#fff', borderRadius: 35, padding: 14 }}>
      <Snippets />
    </div>
  )),
)
